import _ from "lodash";
import React from "react";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import flattenObject from "common/utils/flattenObject";
import SubmitArea from "common/BlocklyLesson/components/SubmitArea";
import styles from "common/BlocklyLesson/styles/MessageBoard.scss";
import ReadmoreButton from "common/BlocklyLesson/components/message_board/ReadmoreButton";
import Timeline from "common/BlocklyLesson/components/message_board/Timeline";
import ExecuteOverlay from "common/BlocklyLesson/components/message_board/ExecuteOverlay";

interface MessageBoardProps {
  store?: any;
  types: string[];
}

class MessageBoard extends React.Component<MessageBoardProps> {
  styleNames = [
    "SendSpeechBalloon",
    "SendProfileIcon",
    "ReceiveSpeechBalloon",
    "ReceiveProfileIcon",
    "ChatInput",
    "SubmitButton",
    "ChatBody",
  ];
  styles: {
    [key: string]: object;
  };

  constructor(props) {
    super(props);
    this.styles = {};
    this.getPastMessages = this.getPastMessages.bind(this);
  }

  getPastMessages() {
    // FIXME: Lesson5-2 Store固有のロジックであるため,共通コンポーネントから削除されるべき
    this.props.store.getPastMessages();
  }

  render() {
    // FIXME: SubmitAreaに渡し,inputのdisabledに利用している. SubmitAreaと合わせてレッスンごとに固有のコンポーネントとするべき
    const { types } = this.props;
    const {
      messages,
      messageBoardStyle,
      isExecute,
      getPastMessages, // FIXME: readmoreボタンの表示フラグとして利用する. クラス内に同名のメソッドが存在し非常に紛らわしいため,適切な命名に変更するべき
      existPastMessage,
      isShowExecuteOverlay,
    } = this.props.store;

    if (messageBoardStyle) {
      // レッスンで提出済みのスタイルにここで上書きされる
      this.styleNames.forEach((styleName) => {
        this.styles[styleName] = flattenObject(
          toJS(messageBoardStyle)[styleName].style
        );
      });
    }

    const sortedUniqueMessages = _.sortBy(_.uniqBy(messages, "messageId"), [
      "createdAt",
    ]);
    const {
      messageboard,
      messageboardWindow,
      messageboardBody,
      messageboardBodyHeader,
      messageboardName,
      messageboardContents,
      messageboardBodyFooter,
      messageboardMoreButton,
    } = styles;

    return (
      <div>
        <div className={messageboard}>
          <div className={messageboardWindow}>
            <div
              className={messageboardBody}
              style={messageBoardStyle ? this.styles.ChatBody : null}
            >
              <div className={messageboardBodyHeader}>
                <div className={messageboardName}>
                  <p>クラスのチャット</p>
                </div>
              </div>
              <div className={`${messageboardContents} messageBoardContents`}>
                {/* FIXME: 同一名称で役割の違う値が存在しているため、適切な命名に変更するか、構造の見直しを行う
                  - getPastMessages は store から取得していて、もっと見るボタンの表示フラグとして利用
                  - this.getPastMessages はもっと見るボタンのクリックイベントハンドラ
                */}
                <ReadmoreButton
                  isShow={!!getPastMessages}
                  handleClick={this.getPastMessages}
                  className={messageboardMoreButton}
                  isExecute={isExecute}
                  hasPastMessage={existPastMessage}
                />
                <Timeline
                  messages={sortedUniqueMessages}
                  userId={this.props.store.userId}
                  hasStudentsDesign={!!messageBoardStyle}
                  styles={this.styles}
                />
              </div>
              <div className={messageboardBodyFooter}>
                <SubmitArea types={types} />
              </div>
            </div>
          </div>
          <ExecuteOverlay
            isShow={isShowExecuteOverlay}
            isExecute={isExecute}
            styles={styles}
          />
        </div>
      </div>
    );
  }
}

export default inject("store")(observer(MessageBoard));
